module.exports = __webpack_public_path__ + "static/media/remote-resume.0149486d.png";